import React from 'react';
import Paragraph from '../typography/Paragraph';
import Heading from '../typography/Heading';

interface SectionHeaderProps {
  heading: string;
  subtitle: string;
  className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  heading,
  subtitle,
  className = '',
}) => {
  return (
    <div className={`text-center max-w-3xl mx-auto mb-4 md:mb-12 ${className}`}>
      <Heading className="mb-2 md:mb-4">{heading}</Heading>
      <Paragraph>{subtitle}</Paragraph>
    </div>
  );
};

export default SectionHeader;
